import React from 'react';
import { logoGooglePlay } from '../../../../assets/images';
import Image from 'next/image';

interface LogoGooglePlayProps {
  sizeClassname?: string;
}

const LogoGooglePlay = ({ sizeClassname }: LogoGooglePlayProps) => {
  return (
    <>
      <Image
        className={`h-[42.73px] w-auto lg:h-[48px] lg:w-[157px] ${sizeClassname}`}
        src={logoGooglePlay.src}
        alt="logo Google Play"
        width={500}
        height={500}
        sizes="(min-width: 380px) 147px, calc(35vw + 21px)"
      />
    </>
  );
};

export default LogoGooglePlay;
